import { render, staticRenderFns } from "./rewardTrafficPermitEdit.vue?vue&type=template&id=59c63cfb&scoped=true&"
import script from "./rewardTrafficPermitEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTrafficPermitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c63cfb",
  null
  
)

export default component.exports